import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TerraDescriptionModule } from '../forms/terra-description';
import { TerraAvatarModule } from '../terra-avatar';
import { TerraBadgeModule } from '../terra-badge';

import { TerraNotificationCardComponent } from './terra-notification-card.component';
import {
  TerraNotificationCardTitleComponent,
  TerraNotificationCardSuffixComponent,
} from './terra-notification-card.slots';

@NgModule({
  imports: [
    CommonModule,
    TerraNotificationCardComponent,
    TerraNotificationCardComponent,
    TerraNotificationCardTitleComponent,
    TerraNotificationCardSuffixComponent,
    TerraDescriptionModule,
    TerraAvatarModule,
    TerraBadgeModule,
  ],
  exports: [
    TerraNotificationCardComponent,
    TerraNotificationCardTitleComponent,
    TerraNotificationCardSuffixComponent,
    TerraAvatarModule,
    TerraDescriptionModule,
  ],
})
export class TerraNotificationCardModule {}
